import { callPostExternalApi } from '@ctn/axios-util';

import { MOCK_SOCIOS, MOCK_SOCIOS_AJENOS, MOCK_SOCIOS_ARCHIVE, MOCK_SOCIOS_ARCHIVE_AJENOS } from '@/pages/LibroSocios/mocks';

import { type IUserAuth } from '@/interfaces/model/user.interface';
import { processError } from '@/utils/axiosErrors';
import axiosInstance from '@/utils/axiosInterceptor';

const getBackendUrlMensajes = () => ({
	GET_LISTADO: '/socios/listado',
	GET_XLS: '/socios/xls'
});

const getListadoSocios = async (history: boolean, user?: IUserAuth) => {
	if (user?.nifEmisor?.toLowerCase() === 'S4878368B'.toLowerCase()) {
		if (history) {
			return {code:200, data: MOCK_SOCIOS_ARCHIVE};
		} 
		return {code:200, data: MOCK_SOCIOS };

	}
	
	if (user?.nifEmisor?.toLowerCase() === 'A78315348'.toLowerCase()) {
		if (history) {
			return {code:200, data: MOCK_SOCIOS_ARCHIVE_AJENOS};
		} 
		return {code:200, data: MOCK_SOCIOS_AJENOS };
	}

	return {code: 200, data: []};
};

const geListadoSociosXLS = async () =>
	callPostExternalApi<string>({
		axiosInstance,
		withCredentials: true,
		url: getBackendUrlMensajes().GET_XLS,
		processError,
	});

export { getListadoSocios, geListadoSociosXLS };
